var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTechnical = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14885 17.3726L9.88916 14.4414",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1109 14.4414L14.8412 17.3826",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53833 5.02736C8.10631 3.22773 9.77293 2.00203 11.66 1.99609H12.3403C14.2274 2.00203 15.8941 3.22773 16.462 5.02736",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3118 10.9795V11.0095C16.1379 13.2621 14.2593 15.0012 12 15.0012C9.74074 15.0012 7.86217 13.2621 7.68823 11.0095V10.9795",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1397 10.9997H7.8604C6.85238 11.0076 6.02376 10.2067 5.99756 9.19894V6.79794C6.02376 5.79022 6.85238 4.98923 7.8604 4.99713H16.1962C17.1849 5.01335 17.9833 5.80931 18.0026 6.79794V9.25351C17.952 10.2417 17.1291 11.0131 16.1397 10.9997Z",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99927 7.49826H14.0009",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99634 21.0039V20.6197C2.99634 19.1889 4.00625 17.9569 5.40934 17.6765L8.62368 17.0332L8.93581 17.2413C10.7912 18.4789 13.2089 18.4789 15.0644 17.2413L15.3765 17.0332L18.5908 17.6765C19.9939 17.9569 21.0038 19.1889 21.0038 20.6197V21.0039",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTechnical);
export default ForwardRef;